/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-14 16:09:43
 * @Description: 维保项目路由
 */
const wbxmRoutes = {
  path: 'wbxm',
  name: 'wbxm',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'wbxmIndex',
      component: () => import(/* webpackChunkName: "wbxmIndex" */'@/features/xfwbgl/wbxm/index.vue'),
      meta: {
        navtabTitle: '维保项目管理',
        isCache: true,
        ignoreDiff: [],
        menuElements: [
          { elementCode: 'wbxmManage_search', elementName: '查询' },
          { elementCode: 'wbxm_scbg_ls', elementName: '生成临时报告' },
          { elementCode: 'wbxm_scbg', elementName: '生成报告' },
          { elementCode: 'wbxm_sqxg', elementName: '申请修改' },
          { elementCode: 'wbxm_gz', elementName: '盖章' }
        ]
      }
    },
    {
      path: 'add',
      name: 'addWbxm',
      component: () => import(/* webpackChunkName: "addWbxm" */'@/features/xfwbgl/wbxm/addWbxm.vue'),
      meta: {
        navtabTitle: '新增维保项目',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'edit/:xmId',
      name: 'editWbxm',
      component: () => import(/* webpackChunkName: "editWbxm" */'@/features/xfwbgl/wbxm/edit.vue'),
      meta: {
        navtabTitle: '编辑维保项目',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'view/:xmId',
      name: 'viewWbxm',
      component: () => import(/* webpackChunkName: "viewWbxm" */'@/features/xfwbgl/wbxm/view.vue'),
      meta: {
        navtabTitle: '查看维保项目',
        isCache: true,
        ignoreDiff: ['showType'],
        menuElements: []
      }
    }
  ]
};

export default wbxmRoutes;
